import * as React from 'react'

interface SeparatorProps {
  separator: React.ReactNode
  testId?: string
}

export function Separator({ separator, testId }: SeparatorProps) {
  if (typeof separator === 'string') {
    return <span data-testid={testId}>{separator}</span>
  }
  return <>{separator}</>
}
